import React, { useEffect, useRef, useState } from "react";
import Drawer from "./Drawer";
import { NavLink, Link, useLocation } from "react-router-dom";
import { MdMenu, MdLogout, MdExpandMore, MdLogin } from "react-icons/md";
import LogoApp from "../../images/kosass.png";
import { AuthService } from "../../services/AuthService";
import oidcAuthService from "../../services/OidcAuthService";

const navLinks = [
	{ to: "/", label: "Home", end: true },
	{ to: "/hostels", label: "Hostels" },
	{ to: "/homestels", label: "Homestels" },
	{ to: "/obuasi-campus", label: "Obuasi Campus" },
	{ to: "/faqs", label: "FAQs" },
	{ to: "/help-desk", label: "Help Desk" },
];

export default function Navbar(props) {
	const [isDrawerOpen, setDrawer] = useState(false);
	const [isDropDownOpen, setDropDown] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const [user, setUser] = useState(null);
	const menuRef = useRef(null);
	const location = useLocation();

	useEffect(() => {
		const fetchUser = async () => {
			const currentUser = await oidcAuthService.getUser();
			setUser(currentUser?.profile);
		};
		fetchUser();
	}, []);

	// close menus and start at the top whenever the route changes
	useEffect(() => {
		setDrawer(false);
		setDropDown(false);
		window.scrollTo(0, 0);
	}, [location.key]);

	// add a shadow once the page is scrolled
	useEffect(() => {
		const onScroll = () => setIsScrolled(window.scrollY > 8);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	// close the account menu on outside click / Escape
	useEffect(() => {
		if (!isDropDownOpen) return;
		const onClick = (e) => menuRef.current && !menuRef.current.contains(e.target) && setDropDown(false);
		const onKey = (e) => e.key === "Escape" && setDropDown(false);
		document.addEventListener("mousedown", onClick);
		document.addEventListener("keydown", onKey);
		return () => {
			document.removeEventListener("mousedown", onClick);
			document.removeEventListener("keydown", onKey);
		};
	}, [isDropDownOpen]);

	const handleLogOut = () => {
		new AuthService().logOut();
		oidcAuthService.logout();
	};

	const initial = (user?.name || user?.email || "U").charAt(0).toUpperCase();

	return (
		<>
			<nav className={`sticky-navbar pn${isScrolled ? " is-scrolled" : ""}`}>
				<div className="pn-inner">
					<Link to="/" className="pn-logo" aria-label="KOSASS home">
						<img src={LogoApp} alt="KOSASS" />
					</Link>

					<ul className="pn-links">
						{navLinks.map((link) => (
							<li key={link.to}>
								<NavLink
									to={link.to}
									end={link.end}
									className={({ isActive }) => `pn-link${isActive ? " is-active" : ""}`}
								>
									{link.label}
								</NavLink>
							</li>
						))}
					</ul>

					<div className="pn-actions">
						{user ? (
							<div className="pn-account" ref={menuRef}>
								<button
									type="button"
									className="pn-account-btn"
									aria-haspopup="menu"
									aria-expanded={isDropDownOpen}
									onClick={() => setDropDown(!isDropDownOpen)}
								>
									<span className="pn-avatar">{initial}</span>
									<span className="pn-account-name">{user?.name?.split(" ")[0] || "Account"}</span>
									<MdExpandMore className="pn-caret" />
								</button>
								{isDropDownOpen && (
									<div className="pn-menu" role="menu">
										<div className="pn-menu-head">
											<span className="pn-avatar pn-avatar--lg">{initial}</span>
											<div>
												<b>{user?.name || "Signed in"}</b>
												{user?.email && <small>{user.email}</small>}
											</div>
										</div>
										<button type="button" role="menuitem" className="pn-menu-item" onClick={handleLogOut}>
											<MdLogout /> Sign Out
										</button>
									</div>
								)}
							</div>
						) : (
							<button type="button" className="pn-login" onClick={() => oidcAuthService.login()}>
								<MdLogin /> Login
							</button>
						)}

						<button
							type="button"
							className="pn-burger"
							aria-label="Open menu"
							aria-expanded={isDrawerOpen}
							onClick={() => setDrawer(true)}
						>
							<MdMenu />
						</button>
					</div>
				</div>
			</nav>
			<Drawer
				isDrawerOpen={isDrawerOpen}
				setDrawer={setDrawer}
				user={user}
				initial={initial}
				onLogout={handleLogOut}
			/>
		</>
	);
}
